<template>
  <div class="no_list_item">
    <img
        src="/images/ic/etc/ic-tea.svg"
        alt=""
    >
    <h6 class="no-drag --grey60 mt20">
      {{ title === undefined ? $t('patients.no_patients') : title }}
    </h6>
  </div>
</template>
<script>
export default {
  props: [
    'title',
  ],
}
</script>